import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { duration } from 'moment';

const durationInMinutes = durationData => duration(durationData).asMinutes();

export default [
  {
    label: 'Zaměstnanec',
    field: 'employee.fullName',
    displayField: 'employee',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Nárok na dovolenou',
    field: 'holidayClaim',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Čerpaná dovolená',
    field: 'holidayTook',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Čerpané nahradní volno za 25% nadčas',
    field: 'holidayForOvertime25PercentTook',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Čerpané nahradní volno za 50% nadčas',
    field: 'holidayForOvertime50PercentTook',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Nárok na volno magivoz',
    field: 'magivozClaim',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Čerpaná dovolená magivoz',
    field: 'magivozTook',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Proplacené nahradní volno za 25% nadčas',
    field: 'payForOvertime25Percent',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Proplacené nahradní volno za 50% nadčas',
    field: 'payForOvertime50Percent',
    mapper: o => durationInMinutes(o),
    type: ColumnType.TEXT,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-workTimes/claim/_claimsColumns.ts